<template>
  <div class="mask-fixed answerQuestion-mask" v-if="isShow">
    <div class="answerQuestion-box">
      <img src="@/assets/questionBank/answerQuestion-close.png" class="answerQuestion-close" @click="close" />
      <div class="answerQuestion-title">答疑</div>
      <div class="answerQuestion-content">
        <div class="answerQuestion-textarea">
          <el-input v-model="content" placeholder="请输入您的问题" resize="none" type="textarea" maxlength="200" class="answerQuestion-inputi" />
          <div class="answerQuestion-limit">
            <span style="color: #1061ff">{{ content.length }}</span>
            <span style="color: #888">/200</span>
          </div>
        </div>
      </div>
      <div class="imgList">
        <div class="imgList-item" v-for="(item, index) in imgList" :key="item.id">
          <el-image :src="item.url" fit="cover" class="imgList-item-img" />
          <img src="@/assets/questionBank/upload-del.png" class="imgList-item-del" @click="delImg(index)" />
        </div>
        <img src="@/assets/questionBank/uploadImg.png" class="imgList-item imgList-add" @click="clickUpload" v-if="imgList.length < 3" />
        <input ref="fileInput" type="file" accept="image/png,image/jpg,image/jpeg" multiple @change="fileChange" class="fileInput" />
        <div class="imgList-item imgList-limit">
          <span style="color: #3366ff">{{ imgList.length }}</span>
          <span>/3</span>
        </div>
      </div>
      <div class="answerQuestion-bottom">
        <div class="answerQuestion-but" @click="submit" v-loading="loading">提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadFile } from "@/utils/uploadTSP";
import { setStyleFixed, exitStyleFixed } from "@/utils/public";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  name: 'AnswerQuestion',
  data() {
    return {
      isShow: false,
      content: "", // 内容
      imgList: [],
      loading: false,
      info: {},
      belongCourseTitleId: "",
      paperId: "",
      imgId: 1
    };
  },
  methods: {
    // 选择图片
    clickUpload() {
      this.$refs.fileInput.value = "";
      this.$refs.fileInput.click();
    },
    
    async fileChange(e) {
      // const files = Array.from(e.target.files).filter((i) => i.type.includes("image"));
      // const arr = files.slice(0, 3 - this.imgList.length);
      // for (const item of arr) {
      //   this.imgList.push({
      //     id: this.imgId++,
      //     url: await uploadFile(item)
      //   });
      // }
    },
    
    delImg(index) {
      this.imgList.splice(index, 1);
    },
    
    // 提交
    submit() {
      if (this.loading) return;
      if (!this.content) {
        this.$message({
          message: "请输入问题内容",
          type: "warning"
        });
        return;
      }
      this.loading = true;
      let arr = [];
      if (this.imgList.length > 0) {
        for (let item of this.imgList) {
          arr.push(item.url);
        }
      }
      // 这里需要替换为Vue 2的API调用方式
      // coachClient.addAnswerQuestion2({
      //   type: 1,
      //   isOffline: 0,
      //   content: this.content,
      //   pictureList: arr.length > 0 ? arr : undefined,
      //   paper: this.paperId,
      //   topic: this.info.questionId ? this.info.questionId : this.info.id,
      //   belongCourseTitleId: this.belongCourseTitleId
      // })
      // .then((res) => {
      //   if (res.code == 0) {
      //     this.$emit("submit");
      //     this.close();
      //   }
      // })
      // .finally(() => {
      //   this.loading = false;
      // });
      
      // 模拟成功响应
      setTimeout(() => {
        this.$emit("submit");
        this.close();
        this.loading = false;
      }, 1000);
    },
    
    open(value) {
      this.info = value;
      if (this.$route.query.belongCourseTitleId) {
        this.belongCourseTitleId = this.$route.query.belongCourseTitleId;
      } else if (this.$route.query.courseNameId) {
        this.belongCourseTitleId = this.$route.query.courseNameId;
      } else if (value.courseId) {
        this.belongCourseTitleId = value.courseId;
      } else if (value.belongCourseTitleId) {
        this.belongCourseTitleId = value.belongCourseTitleId;
      } else {
        this.belongCourseTitleId = "";
      }
      this.paperId = this.$route.query.paperId ? this.$route.query.paperId : "";
      this.isShow = true;
      setStyleFixed();
    },
    
    close() {
      this.content = "";
      this.imgList = [];
      this.isShow = false;
      exitStyleFixed();
    }
  }
};
</script>

<style lang="scss" scoped>
.answerQuestion-mask {
  z-index: 300;
}
.answerQuestion-box {
  width: 740px;
  border-radius: 16px;
  background: linear-gradient(180deg, #e6f0ff 0%, #ffffff 20%);
  position: relative;
  .answerQuestion-close {
    width: 16px;
    height: 16px;
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  .answerQuestion-title {
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    padding: 20px 0;
  }
  .answerQuestion-content {
    padding: 0 20px;
    .answerQuestion-textarea {
      width: 100%;
      height: 200px;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.1);
      padding: 16px 0 0;
      .answerQuestion-inputi {
        height: 150px;
        :deep(textarea) {
          height: 100%;
          color: #333 !important;
          box-shadow: none !important;
          word-break: break-all;
        }
      }
    }
    .answerQuestion-limit {
      text-align: right;
      padding: 0 10px;
      font-size: 14px;
      margin-top: 5px;
    }
  }
  .imgList {
    display: flex;
    padding: 20px 20px 0;
    .imgList-item {
      width: 110px;
      height: 110px;
      border-radius: 8px;
      position: relative;
      margin-right: 16px;
      .imgList-item-img {
        border-radius: 8px;
        width: 100%;
        height: 100%;
      }
      .imgList-item-del {
        width: 24px;
        height: 24px;
        position: absolute;
        top: -8px;
        right: -10px;
        cursor: pointer;
      }
    }
    .imgList-limit {
      font-size: 14px;
      color: #aaa;
      display: flex;
      align-items: flex-end;
    }
    .imgList-add {
      cursor: pointer;
    }
    .fileInput {
      opacity: 0;
      display: none;
    }
  }
  .answerQuestion-bottom {
    width: 100%;
    height: 90px;
    box-shadow: 0px 0px 6px 1px rgba(204, 204, 204, 0.3);
    border-radius: 0 0 16px 16px;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .answerQuestion-but {
      width: 320px;
      height: 50px;
      border-radius: 25px;
      background: linear-gradient(180deg, #97b2ff 0%, #2871ff 100%);
      color: #fff;
      font-size: 16px;
      text-align: center;
      line-height: 50px;
      cursor: pointer;
    }
  }
}
</style>